export default "__VITE_ASSET__Bs_3fO40__"